import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "interactive-card",
  class: "container mx-auto px-2 sm:px-4 py-6 sm:py-8 lg:px-10"
}
const _hoisted_2 = { class: "bg-white border border-gray-200 shadow rounded-2xl p-4 sm:p-6 flex flex-col gap-4 transition" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4" }
const _hoisted_4 = { class: "flex-shrink-0 flex items-center justify-center w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-green-50 mb-2 sm:mb-0" }
const _hoisted_5 = { class: "flex-1 min-w-0 w-full" }
const _hoisted_6 = { class: "flex flex-col sm:flex-row items-start sm:items-center gap-1 sm:gap-2 w-full" }
const _hoisted_7 = { class: "text-lg sm:text-xl font-bold text-gray-900 flex-1 w-full sm:w-auto" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "flex flex-wrap items-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-500 mt-3" }
const _hoisted_10 = { class: "flex items-center gap-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("hr", { class: "my-2 border-gray-100" }, null, -1)
const _hoisted_12 = { class: "flex flex-col sm:flex-row flex-wrap items-start sm:items-center justify-between gap-2" }
const _hoisted_13 = { class: "flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-3 w-full sm:w-auto" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "bg-green-100 text-green-700 text-xs font-semibold px-3 py-1 rounded-full w-max" }, /*#__PURE__*/_toDisplayString("Livro Interativo"), -1)
const _hoisted_15 = { class: "text-xs text-gray-400" }
const _hoisted_16 = ["href"]

import { PropType, ref, computed } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  data: {
    type: Object as PropType<any>,
    default: {},
  },
},
  setup(__props) {

const props = __props;

const route = useRoute();
const h5pId = ref(route.params.h5pId || "");



function formatDate(dateString: string): string {
  if (!dateString) return "";
  const date = new Date(dateString);
  const months = [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  return `${day} de ${month}, ${year}`;
}

const formattedUpdatedAt = computed(() => formatDate(props.data.updatedAt));

function formatDuration(duration: string): string {
  if (!duration) return "";
  const [hours, minutes] = duration.split(":").map(Number);
  if (!isNaN(hours) && !isNaN(minutes)) {
    if (minutes > 0) return `${hours} horas e ${minutes} minutos`;
    else return `${hours} horas`;
  }
  return duration;
}

function safeIconName(name: string) {
  const validIcons = [
    "md-book",
    "bi-pencil-square",
    "md-access-time",
    "md-people",
    "md-star",
  ];
  return validIcons.includes(name) ? name : "md-book";
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_icon, {
            name: safeIconName('md-book'),
            class: "text-green-500 text-2xl sm:text-3xl"
          }, null, 8, ["name"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h2", _hoisted_7, _toDisplayString(__props.data.title), 1),
            _createElementVNode("a", {
              href: `https://wp.homero.app.br/wp-admin/admin.php?page=h5p_new&id=${h5pId.value}`,
              target: "_blank",
              class: "text-gray-400 hover:text-h-primary-500 transition mt-1 sm:mt-0",
              "aria-label": "Editar"
            }, [
              _createVNode(_component_v_icon, {
                name: safeIconName('bi-pencil-square'),
                class: "text-lg sm:text-xl"
              }, null, 8, ["name"])
            ], 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_v_icon, {
                name: safeIconName('md-access-time'),
                class: "text-base"
              }, null, 8, ["name"]),
              _createElementVNode("span", null, _toDisplayString(formatDuration(__props.data.duration) + " de atividades"), 1)
            ])
          ])
        ])
      ]),
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", _hoisted_15, _toDisplayString("Última atualização: " + _unref(formattedUpdatedAt)), 1)
        ]),
        _createElementVNode("a", {
          href: `https://wp.homero.app.br/wp-admin/admin.php?page=h5p&task=show&id=${h5pId.value}`,
          target: "_blank",
          class: "w-full sm:w-auto text-center bg-gradient-to-r bg-h-primary-500 text-white text-sm font-semibold px-5 py-2 rounded-lg shadow hover:opacity-80 transition"
        }, _toDisplayString("Começar Leitura"), 8, _hoisted_16)
      ])
    ])
  ]))
}
}

})